import { CLEAR_PRIVATE_CONTENT } from '../types'
import { clone } from 'lodash/fp'

export type DeeplinkState = {
  route: string
  params: any
}

const deeplinkState: DeeplinkState = {
  route: '',
  params: {},
}

export type DeeplinkAction =
  | {
      type: 'CACHE_DEEPLINK'
      payload: DeeplinkState
    }
  | { type: typeof CLEAR_PRIVATE_CONTENT }
  | {
      type: 'CLEAR_DEEPLINK_CACHE'
    }

const deeplinkReducer = (state = deeplinkState, action: DeeplinkAction) => {
  switch (action.type) {
    case 'CACHE_DEEPLINK':
      return action.payload
    case 'CLEAR_DEEPLINK_CACHE':
      return clone(deeplinkState)
    case CLEAR_PRIVATE_CONTENT: {
      return clone(deeplinkState)
    }
    default:
      return state
  }
}

export { deeplinkState, deeplinkReducer }
